import { useRouter } from 'next/router'
import fetchWithHeaders from '../../configs/fetchWithHeaders'
import Link from 'next/link'
import Head from 'next/head'
import { fetchNavigationMenu } from '../../configs/serverSideNavItems'
import UserLayout from '../../layouts/UserLayout'
import React, { useEffect } from 'react'
import { useBreadcrumbs } from '../../configs/BreadcrumbsContext'

const CategoryPage = ({ category }) => {
  const router = useRouter()
  const { updateBreadcrumbs } = useBreadcrumbs()

  useEffect(() => {
    updateBreadcrumbs([{ label: 'Home', url: '/' }, { label: category.title }])
  }, [category, router.asPath, updateBreadcrumbs])

  if (router.isFallback) {
    return <div>Loading...</div>
  }

  const pageTitle = `${category.title}`
  const pageDescription = `${category.description}`

  const jsonLd = {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    name: pageTitle,
    description: pageDescription,
    url: 'https://calculate-input.com'
  }

  return (
    <>
      <Head>
        <title>{category.title}</title>
        <meta name='description' content={category.description} />
      </Head>
      <div>
        <h1>{category.title}</h1>

        {category.children &&
          category.children.map((child, index) => (
            <div key={index}>
              <h2>
                <Link href={`/${category.path}/${child.path}`} legacyBehavior>
                  {child.title}
                </Link>
              </h2>
            </div>
          ))}
      </div>
    </>
  )
}

export async function getStaticProps({ params, locale }) {
  const menuItems = await fetchNavigationMenu(locale)

  try {
    const res = await fetchWithHeaders(`/page-category/${params.category_page}?lang=${locale}`)
    if (!res.ok) {
      throw new Error(`Failed to fetch category: ${res.statusText}`)
    }
    const category = await res.json()

    return {
      props: {
        category,
        menuItems
      }
    }
  } catch (error) {
    console.error(error.message)

    return {
      notFound: true
    }
  }
}

export async function getStaticPaths({ locales }) {
  // Fetch all categories
  const resCategories = await fetchWithHeaders(`/page-category/all-categories`)
  const categories = await resCategories.json()

  // For each category, create paths for each locale
  const paths = []
  for (let category of categories) {
    for (let locale of locales) {
      paths.push({
        params: {
          category_page: category.path
        },
        locale
      })
    }
  }

  return { paths, fallback: false }
}

CategoryPage.getLayout = page => <UserLayout menuItems={page.props.menuItems}>{page}</UserLayout>

export default CategoryPage
